import styled from 'styled-components';

import {Button} from '../../styles/components/button.style';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  padding: ${props => props.theme.padding};
  text-align: center;
  width: ${props => props.theme.defaultModal.width.desktop};
  ${media.medium`
    width: ${props => props.theme.defaultModal.width.tablet};
  `};
  ${media.small`
    width: ${props => props.theme.defaultModal.width.phone};
  `};
`;

export const Title = styled.div`
  padding: ${props => props.theme.padding};
  font-size: ${props => props.theme.fontSizes.error};
`;

export const Refresh = Button.extend`
  margin: ${props => props.theme.margin};
`;



// WEBPACK FOOTER //
// ./components/Error/Error.style.js